import React, { useMemo } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useQueryWithStore } from 'react-admin';
import Header from './Header'
import Body from './Body'
import Footer from '../controls/Footer'



const useStyles = makeStyles(theme => ({
    main: {
        flex: '1',
        marginRight: '1em',
        marginTop: 20,
    },
    titleLink: { 
        textDecoration: 'none',
         color: 'inherit' 
    },
    card: {
        padding: '16px 0',
        overflow: 'inherit',
        textAlign: 'right',
    },
    title: {
        fontSize: "14px",
    },
    value: {
        padding: '0 16px',
        minHeight: 48,
    },
    avatar: {
        background: theme.palette.background.avatar,
    },
    listItemText: {
        overflowY: 'hidden',
        height: '4em',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },

    tableStyle : {
        margin: "auto",  
        width:"740px" ,
        borderCollapse:"collapse",
        margin: "0px 10px 2px 20px", 
        padding: "0",
        textAlign: "left",
        fontSize: "12px",
        border: '0'
       
    },

    freeStyle : {
        margin: "auto",  
        width:"100%" ,
        borderCollapse:"collapse",
        margin: "0px 10px 2px 20px", 
        padding: "0",
        textAlign: "left",
        fontSize: "12px",
        border: '0'
       
    },
    tableStyleCenter : {
    margin: "auto",  
    width:"740px" ,  
    margin: "20px 10px 2px 20px",  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "center",
    fontSize: "12px",
    fontWeight:'bold'   
    
    },
    
    outerTable : {
    margin: "20px 18px 2px 20px",   
    borderCollapse:"collapse",
    padding: "0",
    width: "780px",

    },
    
    fullTable : {
        with: '100%'
    },
    mainBody :{
        height: '560px',
        
    },

    boxTable: {
        padding: '0px', 
        width: '740px',  
        borderCollapse: 'collapse',
        border: '2px solid black',
    },

    subBody :{
        height: '220px',
        margin: "auto",  
        width:"100%" ,  
        borderCollapse:"collapse",
        padding: "5",
        textAlign: "left",
        fontSize: "12px",
        border: '0'
    },

    hiddenStyle : {
        visibility: "hidden"
    },

    uncDiv :{
        marginBottom : '3px',
        
    },
    uncTD :{
        verticalAlign: 'top',
        width: '16%'
    },

    discloser :{
        textAlign: "center",
        fontSize: "12px",
   
    },
    subdiscloser : {
        textAlign: "center",
        fontSize: "11px",
        fontWeight: 'bold'
    }
}));

const GetSample = ({mode, record}) => {
    const classes = useStyles();
    //console.log(record)
    const { loaded, data: samples } = useQueryWithStore({
        type: 'getList',
        resource: 'samples',
        payload: {
            filter: {
                box_num: record.box_num,
                test_mode: mode
            },
            sort: { field: 'id', order: 'DESC' },
            pagination: { page: 1, perPage: 300 },
        },
    });
    if (!loaded) return null;

    const nb = samples ? samples.reduce(nb => ++nb, 0) : 0;
    //console.log(samples)
    return (
        <div>
            {(nb > 0)  && <Header classes={classes}  record={record} samples={samples}/> }
            {(nb > 0)  && <Body classes={classes}  record={record} samples={samples}/> }    
            {(nb > 0)  && <Footer ><span>Page 1 of 1</span></Footer> }
        </div>
                    
                    
        
    );
                                   
}



export default GetSample;